import _jsx from "@babel/runtime/helpers/jsx";
var _div, _hr, _WalletHeaderBadge, _HeaderBadgeTrigger;
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { AdvertisementText, Glyphicon, PopoverSheet, Text, Image, Button, AccessibilityUtilities, Link } from 'reaxl';
import { useDevice } from '@atc/react-device';
import { HeaderBadgeTrigger } from 'reaxl-header-badge';
import { WalletHeaderBadge } from 'reaxl-wallet';
import { useFeatures } from '@atc/features';
import { header } from 'axl-config';
import HeaderBrand from '../HeaderBrand';
import HeaderSlidingMenu from '../HeaderSlidingMenu';
const {
  navItems,
  brand,
  sponsoredContent
} = header;

// Custom component to swallow active prop to avoid react console warnings
function NavDropdownSection(_ref) {
  let {
    active,
    children,
    className,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: clsx('submenu-links', className)
  }, rest), children);
}
function NavItem(_ref2) {
  let {
    itemData,
    onClick,
    text,
    section,
    onEventKey,
    eventkey,
    linkContext,
    className,
    aClassName,
    ...rest
  } = _ref2;
  const data = itemData;
  const handleNavItemClick = e => {
    onClick(e, data);
    return true;
  };
  return /*#__PURE__*/_jsx("li", {
    className: className
  }, `${text}-${eventkey}`, /*#__PURE__*/React.createElement("a", Object.assign({}, rest, onClick && {
    onClick: handleNavItemClick
  }, {
    className: aClassName
  }), text));
}
const renderHeaderItem = (onClick, data) => /*#__PURE__*/React.createElement(NavItem, Object.assign({
  key: data.eventkey,
  itemData: data,
  onClick: onClick
}, data));
const renderDropdownHeaderItem = _ref3 => {
  let {
    text,
    ...rest
  } = _ref3;
  return /*#__PURE__*/React.createElement("li", Object.assign({
    className: "submenu-header",
    key: text.replace(' ', '')
  }, rest), /*#__PURE__*/_jsx("h5", {}, void 0, text));
};
const handlePartnerClick = (event, details, linkContext, onClick) => {
  event.stopPropagation();
  event.preventDefault();
  onClick(event, {
    ...details,
    linkContext
  });
  window.open(details.link.href);
};
const getSponsoredContent = function (headerSponsoredContent, onClick, isSlidingMenu) {
  if (isSlidingMenu === void 0) {
    isSlidingMenu = false;
  }
  return headerSponsoredContent.map((details, index) => {
    const {
      sponsoredText,
      partner,
      partnerType,
      image,
      link,
      ...rest
    } = details;
    const {
      src,
      alt,
      width,
      height,
      loading,
      lazyload
    } = image;
    const {
      href,
      label
    } = link;
    delete rest.onEventKey;
    const handleImageClick = e => {
      handlePartnerClick(e, details, 'PartnersTileClick', onClick);
    };
    const handleLinkClick = e => {
      handlePartnerClick(e, details, 'PartnersCTAClick', onClick);
    };
    return /*#__PURE__*/_jsx("div", {
      className: clsx('display-flex align-items-center', {
        'margin-top-5': isSlidingMenu
      }),
      "data-cmp": "sponsored-content"
    }, `${partnerType}${partner}${index}`, /*#__PURE__*/_jsx("a", {
      className: "margin-right-4 padding-3 display-flex justify-content-center align-items-center bg-brand-primary rounded-full header-sponsored-image-link",
      onClick: handleImageClick,
      href: href
    }, void 0, /*#__PURE__*/_jsx(Image, {
      src: src,
      alt: alt,
      width: width,
      height: height,
      loading: loading,
      lazyload: lazyload
    })), /*#__PURE__*/_jsx(Text, {
      componentClass: "div",
      size: 200,
      className: "margin-right-2 margin-bottom-2"
    }, void 0, sponsoredText && /*#__PURE__*/_jsx(AdvertisementText, {
      componentClass: "div"
    }, void 0, sponsoredText), /*#__PURE__*/_jsx(Link, {
      undecorated: !isSlidingMenu,
      "data-cmp": "sponsor-link",
      href: href,
      onClick: handleLinkClick
    }, void 0, label)));
  });
};
const renderHeaderDropDownColumn = (_ref4, onClick) => {
  let {
    active,
    items,
    ...rest
  } = _ref4;
  const columnProps = {
    ...rest
  };
  delete columnProps.active;
  return /*#__PURE__*/_jsx("ul", {
    className: "list-unstyled"
  }, columnProps.text, columnProps.text && renderDropdownHeaderItem({
    ...columnProps
  }), items.map(item => {
    const {
      ...itemRest
    } = item;
    const itemClone = {
      ...itemRest,
      linkContext: 'CarResearchLinks',
      aClassName: 'link-undecorated'
    };
    return renderHeaderItem(onClick, itemClone);
  }));
};
function renderNavDropdown(navDropdownItem, headerSponsoredContent, onClick, onSponsorContentReady, showSubmenu, setShowSubmenu) {
  const {
    items,
    text,
    eventkey
  } = navDropdownItem;
  const key = text.replace(' ', '');
  let readyToFireImpression = true;
  const impressionHandler = e => {
    const delay = 1000;
    const dropDown = document?.querySelector('.nav .popover-submenu');
    const isWindowHelper = window && window.getComputedStyle !== undefined;
    setTimeout(() => {
      if (dropDown && isWindowHelper && window.getComputedStyle(dropDown).display === 'block' && readyToFireImpression) {
        headerSponsoredContent.forEach(sponsor => {
          if (sponsor.sponsoredText || sponsor.enableTriggerSponsorImpression) {
            onSponsorContentReady(e, sponsor);
          }
        });
      }
      readyToFireImpression = false;
    }, delay);
  };
  const handleOnHide = () => setShowSubmenu(false);
  const handleOnDropdownClick = e => {
    e.preventDefault();
    setShowSubmenu(prev => !prev);
    impressionHandler(e);
  };
  return /*#__PURE__*/_jsx("li", {}, `${key}-${eventkey}`, /*#__PURE__*/_jsx(Button, {
    bsStyle: "link",
    id: "submenuCta",
    "aria-expanded": showSubmenu,
    onClick: handleOnDropdownClick
  }, void 0, text, /*#__PURE__*/_jsx(Glyphicon, {
    glyph: `chevron-${showSubmenu ? 'up' : 'down'}`,
    className: "text-size-300 margin-left-1 icon"
  })), /*#__PURE__*/_jsx(PopoverSheet, {
    show: showSubmenu,
    role: "menu",
    onHide: handleOnHide,
    className: "popover-submenu",
    position: "center",
    containerElement: _div || (_div = /*#__PURE__*/_jsx("div", {})),
    renderServerSide: true,
    popoverTriggerId: "submenuCta",
    useBottomSheet: false
  }, void 0, /*#__PURE__*/_jsx(NavDropdownSection, {}, void 0, items.map(item => renderHeaderDropDownColumn({
    ...item
  }, onClick))), headerSponsoredContent && headerSponsoredContent.length > 0 && /*#__PURE__*/_jsx(React.Fragment, {}, "popover-sponsored-content-section", _hr || (_hr = /*#__PURE__*/_jsx("hr", {
    className: "display-none display-md-block"
  })), /*#__PURE__*/_jsx("div", {
    className: "sponsored-container"
  }, void 0, getSponsoredContent(headerSponsoredContent, onClick)))));
}
const renderNavigationItem = (item, headerSponsoredContent, onClick, onSponsorContentReady, showSubmenu, setShowSubmenu) => {
  if (item.items) {
    return renderNavDropdown(item, headerSponsoredContent, onClick, onSponsorContentReady, showSubmenu, setShowSubmenu);
  }
  const {
    ...rest
  } = item;
  return renderHeaderItem(onClick, {
    ...rest
  });
};
function Header(_ref5) {
  let {
    brand: headerBrand = brand,
    headerContent,
    navItems: headerNavItems = navItems,
    sponsoredContent: headerSponsoredContent = sponsoredContent,
    className,
    showWallet = false,
    enableWalletPopover = false,
    showHeaderBadge = true,
    onClick = () => {},
    onSponsorContentReady = () => {},
    ...rest
  } = _ref5;
  const [showSubmenu, setShowSubmenu] = useState(false);
  const [isSlidingMenuOpen, setIsSlidingMenuOpen] = useState(false);
  const device = useDevice();
  const isLessThanLg = device?.lessThan?.lg ?? false;
  const {
    capital_one_ads: [isCapitalOneEnabled]
  } = useFeatures(['capital_one_ads']);

  // remove Capital One using feature flag
  const filteredSponsoredContent = !isCapitalOneEnabled ? headerSponsoredContent.filter(item => item?.name?.toLowerCase() !== 'capitalone') : headerSponsoredContent;
  const handleSlidingMenuOpen = () => {
    // disable scroll on document body while sliding menu is open
    document?.body?.classList?.add('sliding-menu-open');
    setIsSlidingMenuOpen(true);
  };
  const handleSlidingMenuClose = () => {
    // enable scroll on document body while sliding menu is closed
    document?.body?.classList?.remove('sliding-menu-open');
    setIsSlidingMenuOpen(false);
  };
  return /*#__PURE__*/React.createElement("header", Object.assign({
    "data-cmp": "header"
  }, rest, {
    className: clsx('navbar navbar-default', className)
  }), /*#__PURE__*/_jsx("div", {
    className: "container-lg"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "navbar-wrapper"
  }, void 0, /*#__PURE__*/_jsx(HeaderBrand, {
    onClick: onClick
  }, void 0, headerBrand(className?.includes('transparent-header'))), /*#__PURE__*/_jsx("div", {
    className: "header-content"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "display-none header-badge"
  }, void 0, /*#__PURE__*/_jsx("span", {
    className: "display-flex align-items-center"
  }, void 0, showWallet && (_WalletHeaderBadge || (_WalletHeaderBadge = /*#__PURE__*/_jsx(WalletHeaderBadge, {}))), showHeaderBadge && (_HeaderBadgeTrigger || (_HeaderBadgeTrigger = /*#__PURE__*/_jsx(HeaderBadgeTrigger, {}))))), headerContent), isLessThanLg && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_jsx("label", {
    htmlFor: "navbar-toggle",
    className: "navbar-toggle sr-hidden cursor-pointer"
  }, void 0, /*#__PURE__*/_jsx(Glyphicon, {
    tabIndex: 0,
    glyph: "list-view",
    className: "text-size-500",
    onClick: handleSlidingMenuOpen,
    onKeyDown: AccessibilityUtilities.withKeyboardAccessibility(handleSlidingMenuOpen)
  })), /*#__PURE__*/_jsx("input", {
    id: "navbar-toggle",
    className: "sr-hidden hidden",
    type: "checkbox",
    "aria-expanded": isSlidingMenuOpen,
    "aria-label": "toggle navigation menu"
  })), !isLessThanLg && /*#__PURE__*/_jsx("nav", {
    "data-cmp": "headerDesktopNav",
    className: "navbar-collapse"
  }, void 0, /*#__PURE__*/_jsx("ul", {
    className: "nav navbar-nav"
  }, void 0, headerNavItems.map(item => renderNavigationItem(item, filteredSponsoredContent, onClick, onSponsorContentReady, showSubmenu, setShowSubmenu)))), isLessThanLg && /*#__PURE__*/_jsx(HeaderSlidingMenu, {
    navItems: navItems,
    sponsoredContent: sponsoredContent,
    isSlidingMenuOpen: isSlidingMenuOpen,
    handleSlidingMenuClose: handleSlidingMenuClose,
    getSponsoredContent: getSponsoredContent,
    onClick: onClick,
    onSponsorContentReady: onSponsorContentReady
  }))));
}
export default Header;